(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const caretSelector = '.menu-caret, .icon-caret';

  document.querySelectorAll('summary.menu-drawer__menu-item, summary.menu-drawer__child-menu-item')
    .forEach((summary) => {

      // 捕获阶段阻止 summary 默认行为
      summary.addEventListener('click', function (e) {
        if (!e.target.closest(caretSelector)) {
          e.preventDefault();   // 阻止展开
          e.stopPropagation();  // 阻止冒泡

          const link = summary.dataset.href;
          if (link) window.location.href = link;
        }
      }, true); // 注意：true => 捕获阶段

      // 兼容键盘操作
      summary.addEventListener('keydown', function (e) {
        if (!e.target.closest(caretSelector) && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          e.stopPropagation();

          const link = summary.dataset.href;
          if (link) window.location.href = link;
        }
      });
    });
});
  } catch(e) { console.error(e); }
})();

})();
